import { gql } from '@apollo/client'

export const ADD_NOTE =  gql`
  mutation addNote( $title: String!, $keyword: String, $content: String, $userId: ID! ){
    addNote( addNoteInput: { title: $title, keyword: $keyword, content: $content, userId: $userId } ){
      _id
      title
    }
  }
`